import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { FindCustomersRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { FindCustomersResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const findCustomers = (request: FindCustomersRequest, options?: CashRequestOptions) =>
  post<FindCustomersRequest, FindCustomersResponse>('/2.0/cash/find-customers', request, {
    ...options,
    rejectOnError: true,
  })
